import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { ToastContainer, useToast } from '../Toast';

// Wraps the ERP toast hook for the Zásilky pages: a stable remove callback (so toast timers are not restarted by
// every re-render) and an aria-live region around the container, so confirmations are announced.
export function useToasts() {
  const toast = useToast();
  const removeRef = useRef(toast.removeToast);
  const showRef = useRef(toast.showToast);
  useEffect(() => {
    removeRef.current = toast.removeToast;
    showRef.current = toast.showToast;
  });

  const remove = useCallback((id) => removeRef.current(id), []);
  const notify = useMemo(() => ({
    success: (message, title = 'Hotovo') => showRef.current({ type: 'success', title, message }),
    error: (message, title = 'Chyba') => showRef.current({ type: 'error', title, message, duration: 8000 }),
    info: (message, title = 'Informace') => showRef.current({ type: 'info', title, message }),
  }), []);

  const host = (
    <div role="status" aria-live="polite">
      <ToastContainer toasts={toast.toasts} onRemove={remove} />
    </div>
  );
  return { notify, host };
}
